document.addEventListener("DOMContentLoaded", function () {
    const popupShown = localStorage.getItem("popupShown");

    if (!popupShown) {
        document.querySelector(".newsletter-popup-section")?.classList.add("show-popup")
        localStorage.setItem("popupShown", "true");
    }
});

document.querySelector(".cross-icon-popup.icon-block__media").addEventListener("click", function() {
  document.querySelector(".newsletter-popup-section.show-popup")?.classList.remove("show-popup");
});